export default __webpack_public_path__ + "static/media/NationalWebLF-Regular.4c7c89a1.ttf";